import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpStabilityService } from '../services/http-stability.service';

/**
 * Recognizes the moment when all the requests are complited and there no pending requests.
 */
@Injectable()
export class HttpStabilityInterceptor implements HttpInterceptor {
    private requestCount = 0;

    constructor(private httpStabilityService: HttpStabilityService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.requestCount++;
        return next.handle(request).pipe(
            finalize(() => {
                this.requestCount--;
                if (this.requestCount === 0) {
                    this.httpStabilityService.markAsStable();
                }
            })
        );
    }
}
